var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "History-entry", on: { click: _vm.showAnime } },
    [
      _c("div", { staticClass: "History-entry__content" }, [
        _c("div", { staticClass: "History-entry__image" }, [
          _c("img", {
            attrs: { src: _vm.anime.image.value, alt: "history anime image" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "History-entry__title" }, [
          _c("p", { staticClass: "History-entry__title__english" }, [
            _vm._v(_vm._s(_vm.anime.title.english.value)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "History-entry__title__japanese" }, [
            _vm._v(_vm._s(_vm.anime.title.japanese.value)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "History-entry__divider" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }